<!-- 职位发布 -->
<template>
  <div class="job_full">
    <div class="job_full_in">

      <header>
        <Button size="small" @click="$router.back()">
          <Icon type="ios-arrow-back" />
          返回
        </Button>
        <Divider type="vertical" />
        <p style="font-size:18px;">{{this.$route.meta.title}}</p>
      </header>
      <section>
        <Spin size="large" fix v-if="spinShow"></Spin>
        <div class="content">

          <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="130">

            <FormItem label="岗位名称" prop="name">
              <Input v-model="formValidate.name" maxlength="10" placeholder="请输入"></Input>
            </FormItem>

            <FormItem label="岗位类型" prop="category">
              <Select v-model="formValidate.category" placeholder="请选择">
                <Option :value="item.type" v-for="item in category" :key="item.type">{{item.name}}</Option>
              </Select>
            </FormItem>

            <FormItem label="岗位时限" prop="timelimit">
              <Select v-model="formValidate.timelimit" placeholder="请选择">
                <Option :value="item.name" v-for="item in timelimit" :key="item.name">{{item.name}}</Option>
              </Select>
            </FormItem>

            <FormItem label="需求人数" prop="need_number">
              <Input v-model="formValidate.need_number" placeholder="请输入">
              <span slot="append">人</span>
              </Input>
            </FormItem>

            <FormItem label="学历要求" prop="education">
              <Select v-model="formValidate.education" placeholder="请选择">
                <Option :value="item.name" v-for="item in education_list" :key="item.name">{{item.name}}</Option>
              </Select>
            </FormItem>

            <FormItem label="可灵活工作时段" prop="work_hour">
              <TimePicker format="HH:mm" hide-disabled-options type="timerange" :disabled-hours="[0,1,2,3,4,5,6,7,8,17,18,19,20,21,22,23]" placeholder="请选择开始/结束时间" v-model="formValidate.work_hour"></TimePicker>
            </FormItem>

            <FormItem label="工作时间" prop="work_time">
              <RadioGroup v-model="formValidate.work_time">
                <Radio label="周一至周五"></Radio>
                <Radio label="周一至周六"></Radio>
                <Radio label="周末上班"></Radio>
                <br>
                <Radio label="其他"></Radio>
                <Input v-model="blur_rest" maxlength="10" placeholder="请输入"></Input>
              </RadioGroup>
            </FormItem>

            <FormItem label="酬劳计算方式" prop="reward_type">
              <Select v-model="formValidate.reward_type" placeholder="请选择">
                <Option :value="item.type" v-for="item in reward_arr" :key="item.type">{{item.name}}</Option>
              </Select>
            </FormItem>

            <!-- 按小时计酬 -->
            <div v-if="formValidate.reward_type == 1">
              <FormItem label="">
                <div style="display:flex;align-items  : center;">
                  <span>酬劳：</span>
                  <InputNumber v-model="formValidate.hour_income" controls-outside placeholder="请输入" type="number" style="margin:0 10px" @on-change="change_hour"></InputNumber>
                  <span>元/小时</span>
                </div>
              </FormItem>
              <FormItem label="">
                <div style="display:flex;align-items  : center;">

                  <span>时长：</span>
                  <InputNumber v-model="formValidate.hour_time" controls-outside placeholder="请输入" :max="8" type="number" style="margin:0 10px" @on-change="change_hour"></InputNumber>

                  <span>小时</span>
                </div>
              </FormItem>
              <FormItem label="">
                <div style="display:flex;align-items  : center;">

                  <span>日酬：</span>
                  <Input v-model="formValidate.reward" placeholder="请输入" type="number" size="small" style="width:93px;margin:0 10px" />
                  <span>元/日</span>
                </div>
              </FormItem>
            </div>

            <!-- 按月计酬 -->
            <FormItem label="" v-else>
              <div style="display:flex;align-items  : center;">

                <span>月酬：</span>
                <Input v-model="formValidate.reward" placeholder="请输入" type="number" size="small" style="width:93px;margin:0 10px" />
                <span>元/月</span>
              </div>
            </FormItem>

            <FormItem label="报名截止时间" prop="indate">
              <RadioGroup v-model="formValidate.indate">
                <div style="display:flex">
                  <Radio label="长期"></Radio>
                  <Radio label="截止时间"></Radio>
                  <Input v-model="blur_indate" maxlength="10" placeholder="请输入"></Input>
                </div>
              </RadioGroup>
            </FormItem>

            <FormItem label="所在区域" prop="workArea">
              <Cascader :data="workArea_data" v-model="formValidate.workArea" trigger="hover" :clearable="false"></Cascader>
            </FormItem>

            <FormItem label="工作地点" prop="address">
              <div class="address">
                <Input v-model="formValidate.address" style="width:90%" placeholder="请点击右边图标选择工作地点"></Input>
                <div style="width:10%">
                  <img @click="open_Modal" src="@/assets/images/B_user/address.png" alt="">
                </div>

              </div>

            </FormItem>

            <FormItem label="岗位描述" prop="description">
              <Input v-model="formValidate.description" type="textarea" :autosize="{minRows: 5,}" placeholder="请输入工作内容/岗位描述"></Input>
            </FormItem>

            <FormItem style="text-align:right">
              <Button type="warning" @click="handleSubmit('formValidate')">{{$route.query.id?'保存修改':'提交发布'}}</Button>
            </FormItem>

          </Form>

        </div>
      </section>
      <Modal v-model="address_model" title="地图选点" :styles="{top: '20px'}" footer-hide>
        <iframe id="mapPage" width="100%" height="800px" frameborder=0 src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=4YYBZ-BIGCG-IMDQT-IOPQG-R77A6-KOFNR&referer=myapp">
        </iframe>
      </Modal>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      spinShow: false,
      //岗位类型
      category: [{
        type: 'civilian',
        name: '人事招聘'
      },
      {
        type: 'mechanic',
        name: '财税'
      },
      {
        type: 'market',
        name: '市场营销'
      },
      {
        type: 'otherCivil',
        name: '其他文职'
      },
      {
        type: 'parttime',
        name: '临时工'
      },
      {
        type: 'factory',
        name: '手工计件'
      },
      {
        type: 'homekeeping',
        name: '家政服务'
      },
      {
        type: 'Other',
        name: '其他'
      }
      ],
      // category: [{
      //   type: 'civilian',
      //   name: '基层文职（行政/人事/前台等）'
      // },
      // {
      //   type: 'mechanic',
      //   name: '专业技能（财税/设计等）'
      // },
      // {
      //   type: 'factory',
      //   name: '一线作业（流水线/手工等）'
      // },
      // {
      //   type: 'general',
      //   name: '企业后勤（保洁/绿化/饭堂等）'
      // },
      // {
      //   type: 'hotel',
      //   name: '酒店餐饮（客房整理/中歺帮忙等）'
      // },
      // {
      //   type: 'market',
      //   name: '市场营销（销售/推广等）'
      // },
      // {
      //   type: 'homekeeping',
      //   name: '家政服务（非住家/清洁/陪护等）'
      // },
      // {
      //   type: 'parttime',
      //   name: '日结兼职（保洁/绿化/饭堂等）'
      // }
      // ],
      //岗位时限
      timelimit: [
        {
          name: '一个月'
        },
        {
          name: '二个月'
        },
        {
          name: '三个月'
        },
        {
          name: '半年'
        },
        {
          name: '长期'
        }
      ],
      //学历要求
      education_list: [
        {
          name: '其他'
        },
        {
          name: '初中'
        },
        {
          name: '高中/中专'
        },
        {
          name: '大专'
        },
        {
          name: '本科及以上'
        },
      ],
      //地级数据
      workArea_data: [
        {
          value: '广东省',
          label: '广东省',
          children: [
            {
              value: '广州市',
              label: '广州市',
              children: [
                {
                  value: '荔湾区',
                  label: '荔湾区',
                },
                {
                  value: '越秀区',
                  label: '越秀区',
                },
                {
                  value: '海珠区',
                  label: '海珠区',
                },
                {
                  value: '天河区',
                  label: '天河区',
                },
                {
                  value: '白云区',
                  label: '白云区',
                },
                {
                  value: '黄埔区',
                  label: '黄埔区',
                },
                {
                  value: '番禺区',
                  label: '番禺区',
                },
                {
                  value: '花都区',
                  label: '花都区',
                },
                {
                  value: '南沙区',
                  label: '南沙区',
                },
                {
                  value: '从化区',
                  label: '从化区',
                },
                {
                  value: '增城区',
                  label: '增城区',
                },
              ]
            },

          ],
        }],
      //酬劳计算方式
      reward_arr: [
        {
          type: '1',
          name: "按小时计酬",
        },
        {
          type: '2',
          name: "按月计酬",
        },
      ],
      formValidate: {
        name: "",
        category: "",
        timelimit: "",
        need_number: "",
        education: "",
        work_hour: "",
        work_time: "周一至周五",
        reward_type: "",
        reward: '',
        indate: "长期",
        gps: {
          x: 1,
          y: 1
        },
        address: '',
        description: ""
      },
      blur_rest: "",
      blur_indate: "",
      ruleValidate: {
        name: [
          { required: true, message: '请填写岗位名称', trigger: 'blur' }
        ],
        category: [
          { required: true, message: '请选择岗位分类', trigger: 'change' }
        ],
        timelimit: [
          { required: true, message: '请选择岗位时限', trigger: 'change' }
        ],

        need_number: [
          { required: true, message: '请输入人数', trigger: 'blur' }
        ],

        education: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        work_hour: [
          { required: true, type: 'array', message: '请选择', trigger: 'change' }
        ],
        work_time: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        reward_type: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        indate: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        workArea: [
          { required: true, message: '请选择所属地区', }
        ],
        description: [
          { required: true, message: '请输入工作内容/岗位描述', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请选择工作地点' }
        ],



      },
      //Modal
      address_model: false,
    }
  },
  methods: {
    //改变按小时计酬
    change_hour() {
      this.formValidate.reward = this.formValidate.hour_income * this.formValidate.hour_time
    },
    //打开地图选点
    open_Modal() {
      this.address_model = true
    },
    //地图选点返回事件
    onMessage(event) {
      let loc = event.data
      if (loc && loc.module == 'locationPicker') {
        //防止其他应用也会向该页面post信息，需判断module是否为
        console.log(loc);
        //选点完毕关闭Modal
        this.address_model = false
        this.formValidate.address = loc.poiaddress + loc.poiname
        console.log(this.formValidate);
        this.formValidate.gps.x = loc.latlng.lng
        this.formValidate.gps.y = loc.latlng.lat
      }
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let new_obj = JSON.parse(JSON.stringify(this.formValidate))
          new_obj.hour_income = new_obj.hour_income + "元/小时"
          new_obj.reward = new_obj.reward_type == 1 ? new_obj.reward + '元/日' : new_obj.reward + '元/月'
          new_obj.work_hour = this.formValidate.work_hour.join('-')
          if (this.formValidate.work_time == '其他') {
            new_obj.work_time = this.blur_rest
          }
          if (this.formValidate.indate == '截止时间') {
            new_obj.indate = this.blur_indate
          }
          if (this.$route.query.id) {

            //修改
            this.$Modal.confirm({
              title: "该职位已发布，修改职位后需重新审核",
              closable: true,
              onOk: () => {
                new_obj._id = this.$route.query.id
                this.spinShow = true
                this.app("enterpriseOperators", "updateFulltimePosition", new_obj).then(res => {
                  console.log(res);
                  this.$Message.warning({
                    content: res.message,
                    duration: 4
                  })
                  if (res.code == 200) {
                    this.$router.push({ name: 'job_manage' })
                  }
                  this.spinShow = false
                })
              }
            })


            console.log(new_obj);

          } else {
            //发布新职位

            if (!this.formValidate.gps || this.formValidate.gps.x == 1) {
              this.$Modal.warning({
                title: "请先地图定位工作地点"
              })
            }
            this.spinShow = true
            this.app("enterpriseOperators", "addFulltimePosition", new_obj).then(res => {
              this.$Modal.warning({
                title: res.message
              })
              if (res.code == 200) {
                this.$router.push({ name: 'job_manage' })
              }
              this.spinShow = false
            })


            console.log(new_obj);

          }


        } else {
          this.$Message.error('请填写齐全资料');
        }
      })
    },
    //封装获取数据
    get_details() {
      this.spinShow = true
      this.app("enterpriseOperators", "getPosition", {
        _id: this.$route.query.id
      }).then(res => {
        this.spinShow = false
        console.log(res);

        //可灵活工作时段回显处理
        let arr1 = []
        arr1[0] = res.result.work_hour.split("-")[0]
        arr1[1] = res.result.work_hour.split("-")[1]
        res.result.work_hour = arr1


        this.formValidate = res.result

        //工作时间数据处理
        if (res.result.work_time != '周一至周五' || res.result.work_time != '周一至周六' || res.result.work_time != '周末上班') {
          this.blur_rest = this.formValidate.work_time
          this.formValidate.work_time = '其他'
        }

        if (res.result.indate != '长期') {
          this.blur_indate = this.formValidate.indate
          this.formValidate.indate = '截止时间'
        }

        this.formValidate.reward_type = this.formValidate.reward_type + ''



      })
    },
  },
  mounted() {
    //接收来自其他页面的消息并判断发送者
    window.addEventListener("message", this.onMessage);
    console.log(this.firm_data);
  },
  created() {

    console.log(this.$route.query.id);
    if (this.$route.query.id) {
      this.get_details()
    }
  }
}
</script>

<style lang="less" scoped>
@import "./job_full.less";
</style>
